import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const ImpersonateIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.6", ...props.sx}} viewBox="0 0 18 14">
        <path
            d="M12.3334 13V11.6667C12.3334 10.9594 12.0525 10.2811 11.5524 9.78105C11.0523 9.28095 10.374 9 9.66675 9H4.33342C3.62617 9 2.94789 9.28095 2.4478 9.78105C1.9477 10.2811 1.66675 10.9594 1.66675 11.6667V13M16.3334 13V11.6667C16.333 11.0758 16.1363 10.5018 15.7743 10.0349C15.4123 9.56791 14.9055 9.23438 14.3334 9.08667M11.6667 1.08667C12.2404 1.23353 12.7488 1.56713 13.1118 2.03487C13.4749 2.50261 13.672 3.07789 13.672 3.67C13.672 4.26211 13.4749 4.83739 13.1118 5.30513C12.7488 5.77287 12.2404 6.10647 11.6667 6.25333M9.66675 3.66667C9.66675 5.13943 8.47284 6.33333 7.00008 6.33333C5.52732 6.33333 4.33342 5.13943 4.33342 3.66667C4.33342 2.19391 5.52732 1 7.00008 1C8.47284 1 9.66675 2.19391 9.66675 3.66667Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
